import {
  loopbackGet, loopbackPost, loopbackPut,
} from '..';
import {
  QuipUser,
  VoucherCode,
  Trial,
  Enrollment,
} from '../../redux/types';

type VoucherWithUserAndEnrollment = VoucherCode & {
  quipUser: Pick<QuipUser, 'email' | 'title' | 'surname' | 'firstname'>;
} & {
  enrollment? : Enrollment;
}

export const getVoucherData = async (trialId: number): Promise<VoucherWithUserAndEnrollment[]> => {
  const uri = `VoucherCodes/getVoucherEnrollList?trialId=${trialId}`;
  return loopbackGet(uri);
};

export const uploadVoucherData = async (
  trialId: number,
  codes: string[],
): Promise<void> => {
  const uri = 'VoucherCodes/uploadVouchers';
  const data = {
    trialId,
    codes,
  };
  return loopbackPost(uri, data);
};

export const getVoucherDetail = async (
  couponCode: string,
  locale: string,
): Promise<VoucherCode & {trial: Trial} | null> => {
  const uri = `VoucherCodes/getVoucherDetails?locale=${locale}&couponCode=${couponCode}`;
  return loopbackGet(uri);
};

export const updateClaimData = async (voucherData: VoucherCode): Promise<VoucherCode> => loopbackPut(`VoucherCodes/${voucherData.id}/claimVoucher`, voucherData);
